<section>
    <div>
        <div *ngIf="!ready">
            <form class="flex" [formGroup]="policyForm" (ngSubmit)="getQoute()">
                <h1 style="font-size: 1.5em;margin-bottom: 0.5em;">Get a Quick Qoute</h1>
                <div class="roe">
                    <label>Select Package</label>

                    <mat-form-field>
                        <mat-label>Select Package</mat-label>
                        <mat-select (selectionChange)="getCountries()" formControlName="packageName">
                            <mat-option *ngFor="let pkg of pkgs" value="{{pkg._id}}"> {{pkg.categoryName}} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="roe">
                    <i *ngIf="s.smLoader" style="float: right;">
                        <mat-icon class="rotate mat-18" style="color: green;">restart_alt</mat-icon>
                    </i>
                    <label for="packageName">Choose a Destination</label>
                    <mat-form-field>
                        <mat-label>Destinations</mat-label>
                        <mat-select (selectionChange)="pullCtryId(policyForm.controls.country.value!)" formControlName="country">
                            <mat-option *ngFor="let country of countries" value="{{country['countryName']}}">
                                {{country['countryName']}} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="roe">
                    <label for="DOB">Your Date of Birth</label>
                    <mat-form-field>
                        <mat-label>DOB</mat-label>
                        <input formControlName="DOB" matInput [max]="minDate" [matDatepicker]="picker">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="roe" >
                    <label for="">Duration of Travel</label>
                    <div class="flex" style="gap: 10px;">
                        <mat-form-field style="flex:1">
                            <mat-label>Start Date</mat-label>
                            <input formControlName="startDate" [min]="minDate" matInput [matDatepicker]="pickerStart">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
                            <mat-datepicker #pickerStart></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field style="flex:1">
                            <mat-label>End Date</mat-label>
                            <input formControlName="endDate" (dateChange)="calcNoDays()"
                                [min]="policyForm.controls.startDate.value" matInput [matDatepicker]="pickerEnd">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix (blur)="calcNoDays()"
                                [for]="pickerEnd"></mat-datepicker-toggle>
                            <mat-datepicker #pickerEnd></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                
                <div *ngIf="noOfDays > 0" style="display: flex;">
                    <p>Duration: &nbsp;</p><h3 style="color: var(--primary-color);">{{noOfDays}} Days</h3>
                </div>
                <div class="roe" style="margin-top: 10px;">
                    <button [disabled]="!policyForm.valid" mat-flat-button color="accent" type="submit">Get Qoute <mat-icon class="mat-18">receipt_long</mat-icon></button>
                </div>
            </form>
        </div>
        <div *ngIf="ready">
            <div>
                <div class="flex" id="ready">
                    <h3>Hey🖐, there your quote is ready</h3>
                    <h1>{{qoute | currency:"NGN "}}</h1>
                    <div style="width: 100%;padding-left: 60px;">
                        <div class="flex" style="justify-content: start;gap:5px;">
                            <div style="width: 70px;">
                                <p style="color:var(--primary-color)">Destination:</p>
                            </div>
                           <div style="flex:1;" style="color: var(--secondary-color);">
                               <b>{{policyForm.controls.country.value | titlecase}}</b>
                           </div> 
                        </div>
                        <div class="flex" style="justify-content: start;gap:5px;">
                            <div style="width: 70px;">
                                <p style="color:var(--primary-color)">Package:</p>
                            </div>
                           <div style="flex:1;" style="color: var(--secondary-color);">
                               <b>{{pullCtgName(policyForm.controls.packageName.value!) | titlecase}}</b>
                           </div> 
                        </div>
                        <div class="flex" style="justify-content: start; gap:5px;">
                            <div style="width: 70px;">
                                <p style="color:var(--primary-color)">Duration:</p>
                            </div>
                            <div  style="flex:1;"  style="color: var(--secondary-color);">
                                <b>{{ noOfDays }} Days</b>
                            </div>
                        </div>
                    </div>
                   <div class="flex" style="width: 100%;gap: 20px;">
                        <button style="color: var(--primary-color) !important;" (click)="ready =!ready" mat-stroked-button color="accent" >Edit <mat-icon class="mat-18">edit</mat-icon></button>
                        <button (click)="move()"  mat-flat-button  color="accent">
                            Proceed
                            <mat-icon class="mat-18">arrow_forward</mat-icon>
                        </button>


                        <!-- <button (click)=""  mat-flat-button color="accent" >Proceed <mat-icon class="mat-18">get_app</mat-icon></button> -->
                   </div> 
                </div>
            </div>
        </div>
    </div>
</section>